export default __webpack_public_path__ + "static/media/discord-s-hover-icon.a10fb994.svg";